<!-- <app-banner></app-banner> -->
@if (showReleaseNotification) {
  <div class="banner banner-click" (click)="bannerClick()">
    <div class="banner-content">
      Notifications are live! You can now tag users and teams in an Event to send them a message - head over to the release notes to read more!
    </div>
    <button class="banner-close" (click)="bannerDismiss($event)" aria-label="Dismiss banner">&times;</button>
  </div>
}
<div class="wrapper" [class.move-down]="showReleaseNotification">
  <div class="sidebar" [class.move-down]="showReleaseNotification" data-color="azure" data-background-color="white" data-image="./assets/img/sidebar-1.jpg" data-testid="admin-sidebar">
    <app-sidebar></app-sidebar>
    <div class="sidebar-background"></div>  <!--style="background-image: url(./assets/img/sidebar-4.jpg)"-->
  </div>
  <div class="main-panel" data-testid="admin-main-panel">
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
    @if (isMaps('maps')) {
      <div>
        <app-footer></app-footer>
      </div>
    }
  </div>
</div>
<ngx-guided-tour [backText]="''" [nextText]="'OK'" [doneText]="doneText" [progressIndicatorLocation]="progressIndicatorLocation"></ngx-guided-tour>
<!-- [skipText]="'Skip'" -->
<app-upgrade-fab></app-upgrade-fab>
<app-stopwatch-popup></app-stopwatch-popup>
